const isObject = require('lodash/isObject');

const Globals = require('../../app/globals');
const UriUtil = require('./util/UriUtil');
const ReactUtil = require('./util/ReactUtil');

const Navigator = {
    paths: {
        dashboard: '/dashboard',
        dashboard_author: '/dashboard_author/',
        dashboard_author_group_view: (groupId) => `/dashboard_author/group/${groupId}`,
        dashboard_student: '/dashboard_student/',
        dashboard_author_view: (viewToken) => `/dashboard_author/view/${viewToken}`,
        dashboard_student_view: (viewToken) => `/dashboard_student/view/${viewToken}`,
        dashboard_author_explore_courses_view: '/dashboard_author/view/explore',
        dashboard_student_explore_courses_view: '/dashboard_student/view/courses_student',
        dashboard_student_purchase_course_view: (courseId) => `/dashboard_student/view/courses_student/course/${courseId}`,
        dashboard_author_purchase_course_view: (courseId) => `/dashboard_author/view/explore/course/${courseId}`,
        dashboard_author_authoring_view: (viewToken) => `/dashboard_author/view/${Globals.view_tokens.dashboard.AUTHORING}/view/${viewToken}`,
        dashboard_author_channel_view: (channelId='', channelView='', channelSubView='') => {
            return `/dashboard_author/view/${Globals.view_tokens.dashboard.AUTHORING}/view/${Globals.view_tokens.author_dash.CHANNEL}/${channelId}${channelView ? `/${channelView}` : ''}${!!channelView && !!channelSubView ? `/${channelSubView}` : ''}`;
        },
        settings: '/settings/',
        activity_view: (channelId, projectId, activityId) => `/project/${channelId}/${projectId}/activity/${activityId}`,
        project_view: (channelId, projectId) => `/project/${channelId}/${projectId}`,
        short_course_view: (channelId, projectId, shortCourseId) => `/project/${channelId}/${projectId}/short_course/${shortCourseId}`,
        short_course_analytics_view: (channelId, projectId, shortCourseId) => `/analytics/${channelId}/${projectId}/short_course/${shortCourseId}`,
    },

    _goTo(history, path, options={}) {
        const navFunc = !!options.replace ? history.replace : history.push;
        const navObj = { pathname: path };
        if (isObject(options.queryObj)) navObj.search = UriUtil.createQueryStringFromObj(options.queryObj, options.addLeadingQuestionMark || false);

        if (options.differentView) {
            window.location.href = path;
            return;
        }
        navFunc(navObj);
    },

    addQueryToCurrentPath: (history, location, options={}) => {
        if (!options.queryObj) {
            console.warn('addQueryToCurrentPath: options.queryObj is required');
            return;
        }

        Navigator._goTo(history, location.pathname, options);
    },

    goToDashboardHome: (history, options={}) => {
        Navigator._goTo(history, Navigator.paths.dashboard, options);
    },

    goToDashboardStudent: (history, options={}) => {
        Navigator._goTo(history, Navigator.paths.dashboard_student, options);
    },

    goToDashboardAuthor: (history, options={}) => {
        Navigator._goTo(history, Navigator.paths.dashboard_author, options);
    },

    goToDashboardAuthorView: (history, viewToken, options={}) => {
        Navigator._goTo(history, Navigator.paths.dashboard_author_view(viewToken), options);
    },

    goToDashboardStudentView: (history, viewToken, options={}) => {
        Navigator._goTo(history, Navigator.paths.dashboard_student_view(viewToken), options);
    },

    goToDashboardAuthorExploreCoursesView: (history, options={}) => {
        Navigator._goTo(history, Navigator.paths.dashboard_author_explore_courses_view, options);
    },

    goToDashboardStudentExploreCoursesView: (history, options={}) => {
        Navigator._goTo(history, Navigator.paths.dashboard_student_explore_courses_view, options);
    },

    goToDashboardStudentPurchaseCourseView: (history, courseId, options={}) => {
        Navigator._goTo(history, Navigator.paths.dashboard_student_purchase_course_view(courseId), options);
    },
    
    goToDashboardAuthorGroupView: (history, groupId, options={}) => {
        Navigator._goTo(history, Navigator.paths.dashboard_author_group_view(groupId), options);
    },

    goToDashboardAuthorPurchaseCourseView: (history, courseId, options={}) => {
        Navigator._goTo(history, Navigator.paths.dashboard_author_purchase_course_view(courseId), options);
    },
    goToDashboardAuthorAuthoringView: (history, viewToken, options={}) => {
        Navigator._goTo(history, Navigator.paths.dashboard_author_authoring_view(viewToken), options);
    },

    goToDashboardAuthorAuthoringChannelView: (history, channelId='', channelView='', options={}) => {
        let channelSubView = options.channelSubView || '';
        if (ReactUtil.isReactEvent(channelView)) {
            channelView = '';
            channelSubView = '';
        }

        Navigator._goTo(history, Navigator.paths.dashboard_author_channel_view(channelId, channelView, channelSubView), options);
    },
    goToSettings: (history, options={}) => {
        Navigator._goTo(history, Navigator.paths.settings, options);
    },

    goToActivityView: (history, channelId, projectId, activityId, options={}) => {
        Navigator._goTo(history, Navigator.paths.activity_view(channelId, projectId, activityId), options);
    },

    goToProjectView: (history, channelId, projectId, options={}) => {
        Navigator._goTo(history, Navigator.paths.project_view(channelId, projectId), options);
    },

    goToShortCourseView: (history, channelId, projectId, shortCourseId, options={}) => {
        Navigator._goTo(history, Navigator.paths.short_course_view(channelId, projectId, shortCourseId), options);
    },

    goToShortCourseAnalyticsView: (history, channelId, projectId, shortCourseId, options={}) => {
        Navigator._goTo(history, Navigator.paths.short_course_analytics_view(channelId, projectId, shortCourseId), options);
    },

};

export default Navigator;